import { styled } from "linaria/react";

export const DatesContainer = styled.div`
  display: flex;
  gap: 0.2rem;

  & > .date {
    white-space: nowrap;
  }
`;
